import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";

import UserTable from "src/pages/Admin/administration/user-management/components/usertable";

const UsersTab = () => (
    <Row>
        <Col xl="12">
            <UserTable />
        </Col>
    </Row>
);

export default withNamespaces()(UsersTab);
